import { render, staticRenderFns } from "./accordion-primary.vue?vue&type=template&id=f4835ef2&scoped=true&"
import script from "./accordion-primary.vue?vue&type=script&lang=js&"
export * from "./accordion-primary.vue?vue&type=script&lang=js&"
import style0 from "./accordion-primary.vue?vue&type=style&index=0&id=f4835ef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4835ef2",
  null
  
)

export default component.exports